import { useSelector, useDispatch } from 'react-redux';
import FJVideoRemoveBgCustomExport from '../view/FJVideoRemoveBgCustomExport';
import { useCallback } from 'react';
import FJActionVideoRemoveBg from '../../../../redux/action/FJActionVideoRemoveBg';
import FJActionEditPage from '../../../../redux/action/FJActionEditPage.js';
import {
    CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
    CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_VIDEOS,
    DEFAULT_FILE_TYPES,
    UPLOAD_FILE_TYPE_NO_GIF,
    UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE,
} from '../../../../config/dataConfig/FJGenerateData.js';
import { FJVideoRemoveBgDataConfig } from '../../../../config/dataConfig/FJVideoRemoveBgDataConfig.js';

const FJVideoRemoveBgAutoExportAfterContainer = () => {
    const dispatch = useDispatch();
    const status = useSelector(state => state.videoBgRemover.autoExportData.exportStatus);
    const progress = useSelector(state => state.videoBgRemover.autoExportData.exportProgress);
    const isApplyButton = useSelector(state => state.common.isApplyButton);

    const download = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.autoExportVideoAction());
    }, [dispatch]);

    const goToBack = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.autoCancelExportVideoAction());
    }, [dispatch]);

    const cancelExport = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.autoCancelExportVideoAction());
    }, [dispatch]);

    const removeMore = useCallback(
        file => {
            dispatch(FJActionVideoRemoveBg.uploadAutoEditVideoAction(file));
        },
        [dispatch],
    );

    const _onEdit = () => {
        dispatch(FJActionVideoRemoveBg.onEditAction());
    };

    const _onClick = () => {
        dispatch(
            FJActionEditPage.openMediaLibraryAction({
                uploadConfig: {
                    isMultiple: false,
                    maxMediaNum: 1,
                    selectedMediaIds: [],
                    acceptTypeWithTranscode:
                        FJVideoRemoveBgDataConfig.ACCEPT_FILE_TYPE + CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_VIDEOS,
                    acceptTypeNoTranscode: [
                        ...FJVideoRemoveBgDataConfig.SUPPORTED_VIDEO_FORMATS,
                        ...DEFAULT_FILE_TYPES,
                    ],
                    suffixTranscode: CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_VIDEOS,
                    // 媒体库的过滤规则
                    mediaFilterFunc: item => {
                        const mediaTypes = ['VIDEO'];
                        return mediaTypes.includes(item.type);
                    },
                    // 上传文件之后返回的数据
                    callbackOptions: {},
                },
            }),
        );
    };

    return (
        <FJVideoRemoveBgCustomExport
            status={status}
            progress={progress}
            download={download}
            goToBack={goToBack}
            cancelExport={cancelExport}
            removeMore={removeMore}
            onEdit={_onEdit}
            onClick={_onClick}
            isApplyButton={isApplyButton}
        />
    );
};

export default FJVideoRemoveBgAutoExportAfterContainer;
